import { render, staticRenderFns } from "./ThumbnailAttachments.vue?vue&type=template&id=32cdbf77"
import script from "./ThumbnailAttachments.vue?vue&type=script&lang=js"
export * from "./ThumbnailAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports